import { PleditorPlugin } from '../PleditorPlugin';
export class TopToolbar extends PleditorPlugin {
    constructor(editor) {
        super(editor);
        this.editor.config.define('balloonToolbar', this.editor.config.get('toolbar'));
    }
    init() {
        const editor = this.editor;
        editor.on('ready', () => {
            var _a, _b, _c;
            const toolbarContainer = document.getElementById('pleditor-toolbar');
            const toolbarUi = (_c = (_b = (_a = editor.ui) === null || _a === void 0 ? void 0 : _a.view) === null || _b === void 0 ? void 0 : _b.toolbar) === null || _c === void 0 ? void 0 : _c.element;
            if (toolbarContainer && toolbarUi) {
                toolbarContainer.appendChild(toolbarUi);
            }
        }, { priority: 'lowest' });
    }
    destroy() {
        var _a, _b, _c;
        const editor = this.editor;
        const toolbarContainer = document.getElementById('pleditor-toolbar');
        const toolbarUi = (_c = (_b = (_a = editor.ui) === null || _a === void 0 ? void 0 : _a.view) === null || _b === void 0 ? void 0 : _b.toolbar) === null || _c === void 0 ? void 0 : _c.element;
        if (toolbarUi && (toolbarContainer === null || toolbarContainer === void 0 ? void 0 : toolbarContainer.contains(toolbarUi))) {
            toolbarContainer === null || toolbarContainer === void 0 ? void 0 : toolbarContainer.removeChild(toolbarUi);
        }
    }
}
